import { NetworkCalls } from "../NetworkCalls";
import React, { FormEvent, useCallback, useEffect, useState } from "react";
import { UserCatchReport } from "../dtos/UserCatchReport";
import CatchesTable from "./CatchesTable";
import { Organisation } from "../dtos/Organisation";
import { UserCatchReportAddFormData } from "../dtos/UserCatchReportAddFormData";
import { Col, Row } from "react-bootstrap";
import NewCatchInputForm from "./NewCatchInputForm";

export default function LoadAndShowCatchReports({
  organisationToken,
  memberNumber,
  lastName,
  organisation,
  enableAdd = false,
}: {
  organisationToken: string | undefined;
  memberNumber: string | undefined;
  lastName: string | undefined;
  organisation?: Organisation;
  enableAdd?: boolean;
}) {
  const [catches, setCatches] = useState<UserCatchReport[]>([]);
  const [validated, setValidated] = useState<boolean>(false);
  const formLabelCols = 3;
  const formInputCols = 12 - formLabelCols;

  const loadCatches = useCallback(async () => {
    if (!organisationToken || !memberNumber || !lastName) {
      return;
    }
    const catchData = await NetworkCalls.getUserCatchReports({
      organisationToken,
      memberNumber,
      lastName,
    });
    catchData.sort((a, b) => b.catchTime - a.catchTime);
    setCatches(catchData);
  }, [organisationToken, memberNumber, lastName]);

  useEffect(() => {
    loadCatches().catch(console.error);
  }, [loadCatches]);

  const onSubmit = (
    event: FormEvent<HTMLFormElement>,
    formData: UserCatchReportAddFormData
  ): Promise<void> => {
    const form = event.currentTarget;
    event.stopPropagation();
    event.preventDefault();

    const checkValidity = form.checkValidity();
    setValidated(true);
    if (!checkValidity) {
      return Promise.reject("Es fehlen Eingaben");
    }

    formData.memberId = memberNumber;
    formData.lastName = lastName;

    return NetworkCalls.addUserCatchResult(formData).then(async () => {
      setValidated(false);
      await loadCatches();
    });
  };

  return (
    <>
      {enableAdd && organisation ? (
        <Row>
          <Col md={6}>
            <CatchesTable catches={catches} />
          </Col>
          <hr className="d-md-none" />
          <Col md={6}>
            <h2>Neuen Fang eintragen</h2>
            <NewCatchInputForm
              onSubmit={onSubmit}
              validated={validated}
              formLabelCols={formLabelCols}
              formInputCols={formInputCols}
              organisation={organisation}
            />
          </Col>
        </Row>
      ) : (
        <CatchesTable catches={catches} />
      )}
    </>
  );
}
